/*
 *
 * MessagesHomePopups
 *
 * @version 1.0.0
 * @author Patrizia Petrera
 * @since 20-Mar-2025
*/

import MessagesHomePopups from './MessagesHomePopupsContainer'

export default MessagesHomePopups
